// WhatsApp helpers — generate wa.me links with pre-filled messages by order status.
// Algerian phone numbers: convert 0XXXXXXXXX → 213XXXXXXXXX (international format without +).

const STORE_NAME = 'Bloom Lingerie';

function normalizeAlgerianPhone(raw) {
  if (!raw) return '';
  let p = String(raw).replace(/[\s\-().]/g, '').trim();
  if (p.startsWith('+')) p = p.slice(1);
  if (p.startsWith('00')) p = p.slice(2);
  // 0XXXXXXXXX (10 digits, leading 0) → 213XXXXXXXXX
  if (/^0[567]\d{8}$/.test(p)) return '213' + p.slice(1);
  // 213XXXXXXXXX already
  if (/^213[567]\d{8}$/.test(p)) return p;
  // Last fallback: strip leading 0
  if (p.startsWith('0')) return '213' + p.slice(1);
  return p;
}

function fmtCurrency(n) {
  try { return new Intl.NumberFormat('fr-DZ').format(Math.round(n)) + ' DA'; }
  catch { return `${n} DA`; }
}

function statusLabel(status) {
  switch (status) {
    case 'pending':
    case 'en_attente':       return 'en attente de confirmation';
    case 'confirmed':        return 'confirmée';
    case 'en_preparation':
    case 'processing':       return 'en préparation';
    case 'fulfilled':
    case 'shipped':          return 'expédiée';
    case 'delivered':
    case 'livre':            return 'livrée';
    case 'cancelled':        return 'annulée';
    default:                 return status || '';
  }
}

function customerFirstName(order) {
  const name = (order.customer_name || '').trim();
  return name ? name.split(' ')[0] : 'cliente';
}

export function buildWhatsAppMessage(order, type = 'auto') {
  const first = customerFirstName(order);
  const oid = order.order_id;
  const total = fmtCurrency(order.total || 0);
  const tracking = order.ecotrack_tracking;
  
  let template = type;
  if (template === 'auto') {
    const s = order.order_status;
    if (s === 'pending' || s === 'en_attente') template = 'pending';
    else if (s === 'confirmed') template = 'confirmed';
    else if (['fulfilled', 'shipped'].includes(s)) template = 'shipped';
    else if (['delivered', 'livre'].includes(s)) template = 'delivered';
    else if (s === 'cancelled') template = 'cancelled';
    else template = 'generic';
  }
  
  switch (template) {
    case 'pending':
      return (
`Bonjour ${first} 🌸,

Merci pour votre commande #${oid} chez ${STORE_NAME} !

Total : ${total}
Livraison : ${order.wilaya || ''}${order.commune ? ' — ' + order.commune : ''}
Mode : Paiement à la livraison

Pourrais-je avoir votre confirmation pour valider la commande ? Je vous appelle juste après.

Merci 💕`
      );
    case 'confirmed':
      return (
`Bonjour ${first} 🌸,

Votre commande #${oid} est bien confirmée ✅
Total : ${total}

Nous préparons votre colis et le remettons à World Express dès que possible. Vous recevrez le numéro de suivi par WhatsApp.

Merci pour votre confiance ! 💕
${STORE_NAME}`
      );
    case 'shipped':
      return (
`Bonjour ${first} 🌸,

Bonne nouvelle ! Votre commande #${oid} a été expédiée 📦
${tracking ? `Numéro de suivi World Express : ${tracking}\n` : ''}Total : ${total}

Le livreur vous contactera avant la livraison.
Préparez le montant : ${total} (paiement à la livraison)

Merci 💕
${STORE_NAME}`
      );
    case 'delivered':
      return (
`Bonjour ${first} 🌸,

Nous espérons que votre commande #${oid} vous plaît !

N'hésitez pas à partager une photo et/ou laisser un avis sur notre site — ça nous aide énormément 🙏

À très bientôt sur ${STORE_NAME} 💕`
      );
    case 'cancelled':
      return (
`Bonjour ${first},

Votre commande #${oid} a bien été annulée. Si c'est une erreur, contactez-nous, on la rétablit en un instant.

Merci pour votre compréhension,
${STORE_NAME}`
      );
    case 'generic':
    default:
      return (
`Bonjour ${first} 🌸,

Concernant votre commande #${oid} (statut : ${statusLabel(order.order_status)}, total ${total}) :

[votre message]

Merci 💕
${STORE_NAME}`
      );
  }
}

export function buildWhatsAppUrl(order, type = 'auto') {
  const phone = normalizeAlgerianPhone(order.customer_phone || '');
  const text = encodeURIComponent(buildWhatsAppMessage(order, type));
  return phone
    ? `https://wa.me/${phone}?text=${text}`
    : `https://wa.me/?text=${text}`;
}
